export enum GroupSessionAttendanceRegistrationProfile {
    dietician = 'Diëtist',
    psychologist = 'Psycholoog',
}
